export const empty_function_ref = function () {}

export const to_string_ref = ({}).toString;

const {isFrozen} = Object

const relative_url_regex = new RegExp('^(?:[a-z]+:)?//', 'i');

export function current_location_url ()
{
  let location = new URL(window.location)
  const data_location_node = document.querySelector('[data-location]')
  if(data_location_node) {
    location = new URL(data_location_node.dataset.location)
  }

  return location
}

export function is_absolute_url (url)
{
  return relative_url_regex.test(url);
}

export function parse_url (url)
{
  if (url instanceof URL)
  {
    return url
  }

  if (!is_absolute_url(url))
  {
    return new URL(url, window.location.href);
  }

  return new URL(url)
}

export function empty (e)
{
  return !!(!is_bool(e) && !is_number(e) && !e ||
    is_object(e) && Object.keys(e).length === 0 ||
    e.length && e.length === 0);
}

export function ensure_array (a)
{
  switch (arguments.length)
  {
    case 0:
      return []
    case 1:
      if (a === undefined || a === null)
        return []
      else if (Array.isArray(a))
        return a
  }

  // return array with a copy of all arguments
  return Array.prototype.slice.call(arguments)
}

export function not_empty (e)
{
  return !empty(e)
}

export function log (msg)
{
  //console.debug(msg)
}

export function global ()
{
  return window && window.window === window && window ||
    global && global.global === global && global
}

export function object_by_name (name, obj_opt)
{
  let parts = name.split('.')
  let cur = obj_opt
  for (var i = 0; i < parts.length; i++)
  {
    cur = cur[parts[i]]
    if (cur == null)
    {
      return null;
    }
  }
  return cur;
}

export function provide (name, object, overwrite, obj_to_export_to)
{
  let parts = name.split('.')
  let cur = obj_to_export_to || global();

  for (let part; parts.length && (part = parts.shift());)
  {
    if (!parts.length && object !== undefined)
    {
      if (!overwrite && is_object(object) && is_object(cur[part]))
      {
        for (let prop in object)
        {
          if (object.hasOwnProperty(prop))
          {
            cur[part][prop] = object[prop];
          }
        }
      }
      else
      {
        cur[part] = object
      }
    }
    else if (cur[part] && cur[part] !== Object.prototype[part])
    {
      cur = cur[part]
    }
    else
    {
      cur = cur[part] = {};
    }
  }
}

export function inherits (child, parent)
{
  function ctor () {}

  ctor.prototype = parent.prototype
  child.prototype = new ctor()
  child.prototype.constructor = child

  child.base = function (me, method) {
    var args = new Array(arguments.length - 2);
    for (var i = 2; i < arguments.length; i++)
      args[i - 2] = arguments[i];

    return parent.prototype[method].apply(me, args);
  }
}

const ENCODED_VALS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
let byteToCharMap = '';
let charToByteMap = '';

function init ()
{
	if (byteToCharMap === '') {
		byteToCharMap = {};
		charToByteMap = {};
		for (var i = 0; i < ENCODED_VALS.length; i++) {
			byteToCharMap[i] = ENCODED_VALS.charAt(i);
			charToByteMap[byteToCharMap[i]] = i;
		}
	}
}

export function string_to_byte_array (str)
{
	const output = [];
	let p = 0;
	for (let i = 0; i < str.length; i++) {
		let c = str.charCodeAt(i);
		while (c > 0xff) {
			output[p++] = c & 0xff;
			c >>= 8;
		}

		output[p++] = c;
	}
	return output;
}

export function byte_array_to_string (bytes)
{
	const CHUNK_SIZE = 8192;
	// Special-case the simple case for speed's sake.
	if (bytes.length <= CHUNK_SIZE) {
		return String.fromCharCode.apply(null, bytes);
	}
	// The remaining logic splits conversion by chunks since
	// Function#apply() has a maximum parameter count.
	// See discussion: http://goo.gl/LrWmZ9
	let str = '';
	for (let i = 0; i < bytes.length; i += CHUNK_SIZE) {
		const chunk = bytes.slice(i, i + CHUNK_SIZE);
		str += String.fromCharCode.apply(null, chunk);
	}
	return str;
}

function decode_string_to_byte_array (input)
{
	init();

	const output = [];

	for (let i = 0; i < input.length;) {
		const byte1 = charToByteMap[input.charAt(i++)];

		const haveByte2 = i < input.length;
		const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
		++i;

		const haveByte3 = i < input.length;
		const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
		++i;

		const haveByte4 = i < input.length;
		const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
		++i;

		if (byte1 == null || byte2 == null ||
		byte3 == null || byte4 == null)
		{
			throw Error();
		}

		const outByte1 = (byte1 << 2) | (byte2 >> 4);
		output.push(outByte1);

		if (byte3 !== 64) {
			const outByte2 = ((byte2 << 4) & 0xF0) | (byte3 >> 2);
			output.push(outByte2);

			if (byte4 !== 64) {
				const outByte3 = ((byte3 << 6) & 0xC0) | byte4;
				output.push(outByte3);
			}
		}
	}

	return output;
}

function encode_byte_array (input)
{
	init();

	const output = [];

	for (let i = 0; i < input.length; i += 3) {
		const byte1 = input[i];
		const haveByte2 = i + 1 < input.length;
		const byte2 = haveByte2 ? input[i + 1] : 0;
		const haveByte3 = i + 2 < input.length;
		const byte3 = haveByte3 ? input[i + 2] : 0;

		const outByte1 = byte1 >> 2;
		const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
		let outByte3 = ((byte2 & 0x0F) << 2) | (byte3 >> 6);
		let outByte4 = byte3 & 0x3F;

		if (!haveByte3) {
			outByte4 = 64;

			if (!haveByte2) {
				outByte3 = 64;
			}
		}

		output.push(byteToCharMap[outByte1],
		byteToCharMap[outByte2],
		byteToCharMap[outByte3],
		byteToCharMap[outByte4]
		);
	}

	return output.join('');
}

export function b64_encode (unencoded)
{
	return encode_byte_array(string_to_byte_array(unencoded))
}

export function b64_decode (encoded)
{
	return byte_array_to_string(decode_string_to_byte_array(encoded));
}

export function b64_url_decode (encoded)
{
	encoded = encoded.replace('-', '+').replace('_', '/');
	while (encoded.length % 4)
		encoded += '=';
	return b64_decode(encoded);
}

export function b64_url_encode (unencoded)
{
	const encoded = b64_encode(unencoded);
	return encoded.replace('+', '-').replace('/', '_').replace(/=+$/, '');
}

export function is_defined (v)
{
  return v != null && typeof v !== 'undefined';
}

export const is_object = (e) => e instanceof Object;
export const is_array = (e) => type(e) === 'array';
export const is_bool = (e) => type(e) === 'boolean';
export const is_symbol = (e) => type(e) === 'symbol';
export const is_number = (e) => type(e) === 'number';
export const is_function = (e) => type(e) === 'function';
export const is_string = (e) => type(e) === 'string';

export function is_tagged (a, ...r)
{
  return is_array(a) && a.raw && isFrozen(a) && r.length + 1 === a.length
}

export function strcmp (a, b)
{
  if (a && b)
  {
    a = a.toString()
    b = b.toString()
    let n, i = 0
    for (n = Math.max(a.length, b.length); i < n && a.charAt(i) === b.charAt(i); ++i) ;

    return i === n ? 0 : (a.charAt(i) > b.charAt(i) ? -1 : 1);
  }
}

export function type (e)
{
  let r = to_string_ref.call(e);
  r = r.split(' ')[1].slice(0, -1).toLowerCase();
  return r;
}
